/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class DeclassificationExemptionsApi extends BaseApi {
    createDeclassificationExemption(declassificationExemption) {
        throwIfNotDefined(declassificationExemption, 'declassificationExemption');
        return this.post({
            path: '/declassification-exemptions',
            bodyParam: declassificationExemption
        });
    }
    deleteDeclassificationExemption(declassificationExemptionId) {
        throwIfNotDefined(declassificationExemptionId, 'declassificationExemptionId');
        const pathParams = {
            declassificationExemptionId
        };
        return this.delete({
            path: '/declassification-exemptions/{declassificationExemptionId}',
            pathParams
        });
    }
    listDeclassificationExemptions(opts) {
        return this.get({
            path: '/declassification-exemptions',
            queryParams: opts
        });
    }
    showDeclassificationExemptionById(declassificationExemptionId) {
        throwIfNotDefined(declassificationExemptionId, 'declassificationExemptionId');
        const pathParams = {
            declassificationExemptionId
        };
        return this.get({
            path: '/declassification-exemptions/{declassificationExemptionId}',
            pathParams
        });
    }
    updateDeclassificationExemption(declassificationExemptionId, declassificationExemption) {
        throwIfNotDefined(declassificationExemptionId, 'declassificationExemptionId');
        throwIfNotDefined(declassificationExemption, 'declassificationExemption');
        const pathParams = {
            declassificationExemptionId
        };
        return this.put({
            path: '/declassification-exemptions/{declassificationExemptionId}',
            pathParams,
            bodyParam: declassificationExemption
        });
    }
}
